import { Customer } from "./customer";
import { Product } from "./product";
import { CustomerAddress } from "./customer-address";
import { User } from "./user";
import { Presentation } from "./presentation";
import { UnitType } from "./unit-type";

export class Order {
    id:number = 0;
    unit_type_id:number = 0;
    unit_type:UnitType = new UnitType(); 
    customer_id:number = 0; 
    customer:Customer = new Customer(); 
    source_customer_id:number = 0; 
    source_customer:Customer = new Customer(); 
    product_id:number = 0; 
    product:Product = new Product(); 
    presentation_id:number = 0; 
    presentation:Presentation = new Presentation(); 
    customer_address_id:number = 0; 
    customer_address:CustomerAddress = new CustomerAddress(); 
    source_customer_address_id:number = 0; 
    source_customer_address:CustomerAddress = new CustomerAddress(); 
    description:string = ''; 
    delivery_date:Date = new Date(); 
    delivery_date_2:Date = new Date(); 
    ton:number = 0; 
    user_id:number = 0;
    user:User = new User();
    status:string = 'Creada';
    who_changed:string = 'Trafico';
    unit_type_presentation:string = 'Sencillo';
    created_at:Date = new Date();
    contracted:boolean = false;
    description_travel: string = '';
    product_date:Date = new Date(); 
    travel_id:number = 0; 
}
